import { useStore } from 'react-redux';
import { IndexRoute, Route, Router } from 'react-router';
import { onEnterApp, onEnterHome, onEnterUnknownRoute } from './actions/app';
import { onEnterMontage } from './actions/montages';
import { onEnterProducts } from './actions/products';
import { onEnterTemplate } from './actions/templates';
import { onEnterEndPointTest } from './actions/test';
import { onEnterTheme, onEnterThemes } from './actions/themes';
import App from './containers/App';
import Home from './containers/Home';
import Login from './containers/login/Login';
import MontageCreation from './containers/montages/MontageCreation';
import MontageEdit from './containers/montages/MontageEdit';
import MontagePreview from './containers/montages/MontagePreview';
import Montages from './containers/montages/Montages';
import Orders from './containers/orders/Orders';
import OrdersUpdate from './containers/orders/OrdersUpdate';
import PackPage from './containers/packs/PackPage';
import Packs from './containers/packs/Packs';
import TemplateEditor from './containers/templateEditor/TemplateEditor';
import TemplatePreview from './containers/templateEditor/TemplatePreview';
import TemplateCreation from './containers/templates/TemplateCreation';
import EndPointTest from './containers/test/EndPointTest';
import Test from './containers/test/Test';
import ThemeCreation from './containers/themes/ThemeCreation';
import ThemeEdit from './containers/themes/ThemeEdit';
import ThemePreview from './containers/themes/ThemePreview';
import Themes from './containers/themes/Themes';

const Routes = (props) => {
  const store = useStore();
  const { history } = props;

  return (
    <Router history={history}>
      <Route path="templateImage-:templateId" component={TemplatePreview} onEnter={onEnterTemplate(store)} />
      <Route path="/" component={App} onEnter={onEnterApp(store)}>
        <IndexRoute component={Home} onEnter={onEnterHome(store)} />

        <Route path="login" component={Login} />

        <Route path="templateCreation" component={TemplateCreation} />
        <Route path="template-:templateId" component={TemplateEditor} onEnter={onEnterTemplate(store)} />

        <Route path="montageCreation" component={MontageCreation} />
        <Route path="montages" component={Montages} />
        <Route path="montageEdit-:montageId" component={MontageEdit} onEnter={onEnterMontage(store)} />
        <Route path="montage-:montageId" component={MontagePreview} onEnter={onEnterMontage(store)} />

        <Route path="themeCreation" component={ThemeCreation} />
        <Route path="themes" component={Themes} onEnter={onEnterThemes(store)} />
        <Route path="themeEdit-:themeId" component={ThemeEdit} onEnter={onEnterTheme(store)} />
        <Route path="theme-:themeId" component={ThemePreview} onEnter={onEnterTheme(store)} />

        <Route path="orders" component={Orders} />

        <Route path="test" component={Test} />

        <Route path="updateOrderAssets" component={OrdersUpdate} />

        <Route path="endPointImageTest-:imageId" component={EndPointTest} onEnter={onEnterEndPointTest(store)} />

        <Route path="packs" component={Packs} />
        <Route path="pack-:packId" component={PackPage} onEnter={onEnterProducts(store)} />

        <Route path="*" onEnter={onEnterUnknownRoute(store)} />
      </Route>
    </Router>
  );
};

export default Routes;
